import PropTypes from 'prop-types'
import React from 'react'
import Svg from 'Svg'
import css from './AppStoreLinks.css'
import { getAppStoreUrl, getPlayStoreUrl } from './storeUrls'

const AppStoreLinks = ({ appStoreId, playStoreId, tracking }) => {
const onAppLinkClick = (e) => {
  const { href } = e.currentTarget
  e.preventDefault()
  tracking()
  window.location.assign(href)
}

return (
    <div className={css.appStoreContainer}>
      <a
        className={css.playstoreLink}
        onClick={(e) => onAppLinkClick(e)}
        href={getPlayStoreUrl(playStoreId)}
      >
        <Svg label="play store" fileName="icon-Playstore-bw" className={css.playStoreSvg} />
      </a>
      <a
        className={css.appstoreLink}
        onClick={(e) => {onAppLinkClick(e)}}
        href={getAppStoreUrl(appStoreId)}
      >
        <Svg label="app store" fileName="icon-Appstore-bw" className={css.footerAppleAppstoreSvg} />
      </a>

    </div>
  )
}

AppStoreLinks.propTypes = {
  appStoreId: PropTypes.string.isRequired,
  playStoreId: PropTypes.string.isRequired,
  tracking: PropTypes.func,
}

AppStoreLinks.defaultProps = {
  tracking: () => {}
}

export { AppStoreLinks }
